import React, { useMemo } from 'react';
import { Progress } from 'tea-component';
import { getShowCount } from '@/pages/opinion/utils';

type ProgressProps = {
  count: number;
  total_count: number;
  precent: number;
};

export default function ProgressBox({
  count,
  total_count,
  precent,
}: ProgressProps) {
  const width = useMemo(() => {
    if (precent) {
      return precent;
    }

    let width = 0;
    if (!isNaN(total_count) && !isNaN(count) && total_count > 0) {
      width = count / total_count;
      if (width > 1) width = 1;
    }

    return width;
  }, [count, total_count, precent]);

  return (
    <div className="community-render-norm">
      <p>{count && count !== -1 ? getShowCount(count) : '-'}</p>
      <Progress
        className="dbo-progress-box"
        percent={width * 100}
        strokeWidth={4}
        theme={'default'}
      />
    </div>
  );
}
